import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    SelectField,
    EditButton,
    CardActions,
    ShowButton,
    CreateButton,
    useListContext,
    FunctionField
} from 'react-admin';
import ContractStatuses from "../helper/ContractStatuses";
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ContractRequestEditButton from "../component/ContractRequestEditButton";
import Filter from './Filter';
import programs from "../helper/MedicalProgramsList";

const rowStyle = (record) => ({
    backgroundColor: record.status === 'NHS_SIGNED' ? '#bbffbb' : 'white',
});

const ContractRequestActions = ({
                             bulkActions,
                             basePath,
                             currentSort,
                             displayedFilters,
                             exporter,
                             filters,
                             filterValues,
                             onUnselectItems,
                             resource,
                             selectedIds,
                             showFilter,
                             total
                         }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <CreateButton label={"Створити"} basePath={basePath} />
    </CardActions>
);
const CustomShowBtn = props => {
    return (<ShowButton label={props.record.id} {...props}/>)
}

const Empty = () => {
    const { basePath, resource } = useListContext();
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Заявки на договір - відсутні
            </Typography>
            <Typography variant="body1">
                Створити заявку на договір?
            </Typography>
            <CreateButton basePath={basePath} label="створити" />
        </Box>
    );
};

const contractTypeTranslation = {
    REIMBURSEMENT: "Реімбурсація",
    CAPITATION: "Капітація"
}

export const ContractRequestList = (props) => (
    <List {...props}
          filters={<Filter />}
          bulkActionButtons={false}
          currentSort={{ field: 'createdAt', order: 'DESC' }}
          perPage={25}
          title="Заявки на договір"
          actions={<ContractRequestActions />}
          className="list-styles"
          empty={<Empty />}
    >
        <Datagrid rowStyle={rowStyle}>
            <CustomShowBtn />
            <FunctionField source="contractType" label="Тип договору" sortable={false} render={record => contractTypeTranslation[record.contractType]} />
            <FunctionField source="status" label="Мед. програма"
                           render={record => {
                               let result = [];

                               if (record.medicalProgramId) {
                                   for (let i = 0; i < record.medicalProgramId.length; i++) {
                                       result.push(programs[record.medicalProgramId[i]]);
                                   }
                               }

                               return result.length > 0 ? result.join(', ') : '';
                           }} />
            <SelectField label="Статус" source="status" sortable={false} choices={ContractStatuses} />
            <TextField label="Статус (подробиці)" source="statusReason" sortable={false} />
            <DateField label="Дата початку" source="startDate" sortable={false} options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
            <DateField label="Дата закінчення" source="endDate" sortable={false} options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
            {/*<ContractRequestEditButton label={"Редагувати"} />*/}
        </Datagrid>
    </List>
);

export default ContractRequestList;
